import { useEffect, useState } from "react"
import Loading from "../components/Loading/Loading";
import { makeStyles,Grid, Typography, Snackbar } from "@material-ui/core";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import * as reportActions from "../actions/reportActions";
import { connect } from "react-redux";
import { reportDownloadData } from "../services/ReportService";
import {downloadPdf} from "../utilities/applicationutils";
import * as miscAction from "../actions/miscAction";
var CONTROLS_DATA = require("./ControlsData.json");
var ADMIN_CONTROLS = CONTROLS_DATA.SCREENS.ADMIN_REPORTS;

const Reports = ({
getCustomerReports,
getReportListAction,
reportListData,
modelState,
miscState,
userInfo,
setSnackBar
}) => {
    console.log('checking information',userInfo);
    const [customerReportName, setCustomerReportName] = useState("");
    const [loading, setLoading] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [userReportId, setUserReportId] = useState((miscState.selectedModel === "ADMIN") ? null : (miscState.selectedModel === "REGION") ? localStorage.getItem("regionIdValue") : localStorage.getItem("salesOfficeValue"));
    const useStyles = makeStyles((theme) => ({
      paper: {
        position: "absolute",
        width: 400,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
        maxHeight: "75%",
      },
      gridHeaderColumns: {
        display: "grid",
        width: "100%",
        gridTemplateColumns: "97% 3%",
        color: "#617080",
        fontSize: "14px",
        fontFamily: "Arial",
        fontWeight: "500",
      }
      }));

      function getModalStyle() {
        const top = 50;
        const left = 50;
    
        return {
          top: `${top}%`,
          left: `${left}%`,
          transform: `translate(-${top}%, -${left}%)`,
        };
      }
    const classes = useStyles();

    const [modalStyle] = useState(getModalStyle);

    useEffect(() => {
      const fetchReportList = async() => {
        try{
            await getReportListAction(miscState.selectedModel);
        }
        catch(error){
          setSnackBar(true,"error", error.message || "Api error while downloading reports");
        }
      }
      fetchReportList();
    },[getReportListAction,userInfo]);
    
    useEffect(() => {
        const ctrlData = [];
        console.log('testing model state',modelState);
        console.log('testing report list',reportListData);
        reportListData.forEach((model) => {
          ctrlData.push({
            rowKey: model.reportId,
            customerReportName: model.reportDescription,
            rowValue: [
              {
                colType: "grid-label",
                colOptions: {
                  width: "100px",
                  value: model.reportDescription,
                  tab: "reports",
                  model: model,
                  //onUpdate: onUpdateModelName,
                },
              },          
              {
                colType: "grid-actions",
                colOptions: [
                  {
                    name: "download",
                    tab: "reports",
                    action: () => onEdit(model),
                    width: "100px",
                  }
                ],
              },
            ],
          });
        });
        setGridData(ctrlData);
      }, [reportListData]);
      const onEdit = async (reportRecord) => {
        window.startLoading();
        try{
          let urlMaking = (miscState.selectedModel === "ADMIN") ? reportRecord.reportEndpoint : (miscState.selectedModel === "REGION") ? `${reportRecord.reportEndpoint}\?regionId=${userReportId}` : `${reportRecord.reportEndpoint}\?salesOfficeID=${userReportId}`;
          console.log("url", urlMaking);
          // urlMaking = "/report/admin/getStateOfBusiness";
          const downloadData = await reportDownloadData(urlMaking);
            downloadPdf(downloadData);
            console.log('checking data',downloadData);
          window.stopLoading();
        }
        catch(error){
          setSnackBar(true,"error",error.message || "Api error while downloading reports")
          window.stopLoading();
        }
      }

     
    return(
        <div container className="page-container content-center">
            <Loading open={loading}/>
            <Grid container xs={12} md={11} className="page-content">
            {gridData?.length == 0 &&      
            <Grid item container xs={12} md={11}>
              <Typography className="license-noresults" gutterBottom sx={{paddingLeft:10}}>No Results Found</Typography>
            </Grid>
            }
            <Grid item container xs={12} md={11}>
            {gridData?.length > 0 && (
            <DMGrid
                key={Math.random()}
                headers={ADMIN_CONTROLS.GRID_HEADERS}
                headerClassName={classes.gridHeaderColumns}
                data={gridData}
                loading={loading}
                setGridData={(t) => {
                    setGridData(t);
                }}
            />
            )}
            </Grid>
            </Grid>
        </div>    
    )
}

const mapStateToProps = (state) => ({
  modelState:state,
  miscState: state.misc,
  reportListData: state.reportsList.reports.reportList
});

const mapDispatchToProps = (dispatch) => {
  return {
    getReportListAction: async(payload) => dispatch(reportActions.getReportListAction(payload)),
    setSnackBar: (show, severity, message) =>dispatch(miscAction.setSnackBar(show, severity, message))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Reports);